import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { EnterPriseGroupService } from 'src/app/services/enterpriseGroup.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ThemePalette } from '@angular/material/core';
import { UserManagementService } from 'src/app/services/usermanagement.service';
import { ProductivityService } from 'src/app/services/productivity-service';
import { Options } from 'highcharts';
import { Chart } from 'angular-highcharts';
import * as Highcharts from 'highcharts/highcharts';
import * as moment from 'moment';
import { TranslaterService } from 'src/app/services/translater.service';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { Multilingual } from 'src/app/services/multilingual';
import { BaseApi } from 'src/backend/api/base-api';
declare var require: any;
require('highcharts/modules/funnel')(Highcharts);


@Component({
  selector: 'app-safety-trends',
  templateUrl: './safety-trends.component.html',
  styleUrls: ['./safety-trends.component.scss']
})
export class SafetyTrendsComponent implements OnInit {
  @ViewChild('safetyPyramidModal') private safetyPyramidModal!: TemplateRef<any>;
  @ViewChild('safetyPyramidAddFatalAccident') private safetyPyramidAddFatalAccident!: TemplateRef<any>;

  languageDir = 'ltr';
  lang: any;
  moduleId: any;
  pageId: any;
  langObj: any;
  constructor(
    private formBuilder: FormBuilder,
    private toaster: ToastrService,
    private dialog: MatDialog,
    private productivityservice: ProductivityService,
    public router: Router,
    private translater: TranslaterService,
    private translate: TranslateService,
    private baseApi: BaseApi
  ) {
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => { event.lang === 'ar' ? this.languageDir = 'rtl' : this.languageDir = 'ltr'; this.getLangWords(); })
    this.columnDefs = [
      { headerName: 'Event Date', field: 'StartTime', filter: 'agDateColumnFilter', valueFormatter: function (params: any) { return params.value !== null ? moment(params.value).format('MM/DD/YYYY HH:mm:ss') : '' }, headerValueGetter: this.localizeHeader.bind(this) },
      { headerName: 'YTD', field: 'Remarks', filter: 'agTextColumnFilter', headerValueGetter: this.localizeHeader.bind(this) },
      { headerName: 'Target', field: 'Frequency', filter: 'agTextColumnFilter', headerValueGetter: this.localizeHeader.bind(this) },
      { headerName: 'W.Manhours', field: 'UserName', filter: 'agTextColumnFilter', headerValueGetter: this.localizeHeader.bind(this) },
      { headerName: 'BR Manhours', field: 'PreTaskImage', filter: 'agTextColumnFilter', headerValueGetter: this.localizeHeader.bind(this) },
    ]
  }

  // form unitDetailForm fields controls
  public showSpinners = true;
  GroupList!: any[];
  PlantList1!: any[];
  public showSeconds = false;
  public touchUi = false;
  public enableMeridian = false;
  public minDate: moment.Moment | undefined;
  public maxDate: moment.Moment | undefined;
  public stepHour = 1;
  public stepMinute = 1;
  public stepSecond = 1;
  public color: ThemePalette = 'primary';
  permisson!: any;
  IsAccess!: any;
  IsWrite!: any;
  breadcrumList!: any;
  isPopupMachine = false;
  history = false
  rowData!: any[];
  columnDefs!: any[];
  gridApi: any;
  gridColumnApi: any;


  gridOptions: any = {
    defaultColDef: {
      rowModelType: 'infinite',
      paginationPageSize: 5,
      infiniteInitialRowCount: 2,
      flex: 1,
      sortable: true,
      resizable: true,
      wrapText: true,     // <-- HERE
      autoHeight: true,   // <-- & HERE
      minWidth: 225,
      filter: 'agTextColumnFilter',
      floatingFilterComponentParams: {
        suppressFilterButton: false,
      },
      filterParams: { newRowsAction: 'keep' },
    },
    // headerHeight: 150,
    popupParent: document.querySelector('body'),
    // floatingFilter: true,
  };
  menuRedIconUrl = 'assets/images/menu-bottom-red-icon.png';
  menuGreenIconUrl = 'assets/images/menu-bottom-green-icon.png';
  chartPyramid!: Chart;
  options!: Options;
  public formGroup = new FormGroup({
    date: new FormControl(null, [Validators.required]),
  });

  safetyTrendsForm!: FormGroup;
  SafetyPyramidDetailForm!: FormGroup;
  AddFatalAccidentForm!: FormGroup;
  UnitNode: any;
  Group: string | undefined;
  length: boolean = false;
  inputReadonly = true;
  ngOnInit(): void {
    this.getLangWords();
    // // this.spinner.show(); 
    this.initFormSafetyTrendsForm();
    this.initFormSafetyDetails();
    this.initFormAddFatalAccident();
    this.drawPyramid();
  }
  initFormAddFatalAccident() {
    this.AddFatalAccidentForm = this.formBuilder.group({
      department: [],
      description: [],
      eventDate: [],
    });
  }

  initFormSafetyTrendsForm() {
    this.safetyTrendsForm = this.formBuilder.group({
      startDate: [],
      endDate: [],
    });
  }

  initFormSafetyDetails() {
    this.SafetyPyramidDetailForm = this.formBuilder.group({
      trirytd: [],
      trirtarget: [],
      workingmanhour: [],
      bestrecordman: [],
    });
  }
  ;

  ngAfterViewInit(): any {

  }

  onSubmit(): void {


  }


  openPopupSafetyPyramidDetail(event: any, type: string): void {
    type === 'history' ? this.history = true : this.history = false;
    this.dialog?.open(this.safetyPyramidModal, {
      width: '50vw !important',
      height: 'auto',
      minWidth: '50vw',
    });
  }

  openPopupSafetyPyramidAddFatalAccident(value: any) {
    if (value.point.name === 'Unsafe Situation[Hazard]') {
      this.dialog?.open(this.safetyPyramidAddFatalAccident, {
        width: '50vw !important',
        height: 'auto',
        minWidth: '50vw',
      });
    }
  }
  public localizeHeader(parameters: any) {
    let headerIdentifier = parameters.colDef.field;
    return this.getTransalatedValue(headerIdentifier);
  }
  getTransalatedValue(value: string) {
    let val;
    if (this.langObj && this.langObj[value]) {
      val = this.langObj[value];
    }
    return val ? val : value;
  }
  public getLangWords() {
    this.pageId = this.baseApi.getCurrentMenuID();
    const userMenus = this.baseApi.getUserPermissionsSession();
    this.moduleId = userMenus.find(x => x.menuId === this.pageId)?.parentId;
    const key = {
      ModuleId: this.moduleId,
      PageId: this.pageId,
      LanguageId: this.translate.currentLang === 'en' ? 1 : this.translate.currentLang === 'ar' ? 2 : this.translate.currentLang === 'fr' ? 3 : this.translate.currentLang === 'sp' ? 4 : 1
    };
    this.translater.getLangWords(key).subscribe((res: any) => {
      let obj: any = {};
      res.tagList.map((elem: any) => {
        obj[elem.tagName] = elem.translatedValue;
      });
      this.langObj = obj;
    });
  }

  //===================================================== Save Safety Pyramid Details==========================//
  saveSafetyDetail(): void {

  }

  //================================================== Pyramid Chart=============================================//
  drawPyramid() {
    // let dtLabel: any[] = new Array();
    // let dtData: any[] = new Array();
    // if (data !== null) {
    //   data.forEach((element: any) => {
    //     dtLabel.push(element.Month);
    //     dtData.push([element.Month, parseFloat(element.AvgMonthlyOEE)]);
    //   });
    // }
    this.options = {
      chart: {
        type: 'pyramid',
        marginRight: 100
      },
      credits: {
        enabled: false
      },
      title: {
        text: '',
        x: -50
      },
      plotOptions: {
        series: {
          dataLabels: {
            enabled: true,
            format: '<b>{point.name}</b> ({point.y:,.0f})'
          },
          cursor: 'pointer',
          events: {
            click: this.openPopupSafetyPyramidAddFatalAccident.bind(this)
          }
        },

      },
      legend: {
        enabled: false
      },
      series: [{
        name: 'Safety pyramid',
        type: 'pyramid',
        data: [
          ['Fatal Accident', 120],
          ['Last time Injury', 100],
          ['Medical Treatment Case', 60],
          ['First Aid', 80],
          ['Fire Incident', 100],
          ['Near Miss', 120],
          ['Unsafe Situation[Hazard]', 140],
        ]
      }],

      responsive: {
        rules: [{
          condition: {
            maxWidth: 600
          },
          chartOptions: {
            plotOptions: {
              series: {
                dataLabels: {
                  inside: true
                },

              }
            }
          }
        }]
      }

    };
    let chart = new Chart(this.options);
    this.chartPyramid = chart;
  }
  //============================================================= AG Grid==================================================//
  onGridReady(params: any): any {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  excelExport() {
    this.gridApi.exportDataAsExcel();
  }
  csvExport() {
    this.gridApi.exportDataAsCsv();
  }
}

